import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { RecipeIngredientModel } from 'src/app/core/model/object/recipe-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';

import { CookingStoryRecipePageDataService } from 'src/app/data/repository/cooking-story/cooking-story-recipe-page-data.service';
import { CookingStoryBottomSheetChangeValueComponent } from './cooking-story-bottom-sheet-change-value/cooking-story-bottom-sheet-change-value.component';

@Component({
  selector: 'app-cooking-story-bottom-sheet',
  templateUrl: './cooking-story-bottom-sheet.component.html',
  styleUrls: ['./cooking-story-bottom-sheet.component.scss'],
})
export class CookingStoryBottomSheetComponent implements OnInit, OnDestroy {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  selectedItem: string[] = [];
  ingredients: RecipeIngredientModel[];
  subscriptions: Subscription[] = [];
  edditting: boolean = true;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      ingredients: RecipeIngredientModel[];
    },
    private bottomSheetRef: MatBottomSheetRef<CookingStoryBottomSheetComponent>,
    private RecipePageDataService: CookingStoryRecipePageDataService,
    private matBottomSheet: MatBottomSheet,
    private cookingStoryGroceryService: CookingStoryGroceryService
  ) {
    this.edditting = false;
  }

  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  ngOnInit(): void {
    if (this.RecipePageDataService.getItemsSize() > 0) {
      this.ingredients = this.RecipePageDataService.getBackupSaves();
      this.selectedItem = this.RecipePageDataService.getItems().map(
        (data) => data._id
      );
    } else {
      this.ingredients = this.data.ingredients.slice();
      this.RecipePageDataService.addItems(this.data.ingredients.slice());
      this.toggleData();
    }
  }
  toggleData() {
    this.data.ingredients.map((item) => {
      this.toggleIngredients(item._id);
    });
  }

  toggleIngredients(id: string) {
    let item = this.selectedItem.find((x) => x == id);

    const selectedItem: RecipeIngredientModel = this.ingredients.filter((d) => {
      return d._id == id;
    })[0];

    const data = new RecipeIngredientModel(
      null,
      selectedItem.cooked,
      selectedItem.food,
      null,
      selectedItem._id,
      selectedItem.unitDescription,
      selectedItem.description,
      selectedItem.kitchenInventory,
      selectedItem.unit
    );
    if (!selectedItem.kitchenInventory) {
      if (item) {
        this.selectedItem = this.selectedItem.filter(
          (x) => x != selectedItem._id
        );
      } else {
        this.selectedItem.push(selectedItem._id);
      }

      this.RecipePageDataService.addItem(data);
    } else {
      this.RecipePageDataService.updateSaveItem(data);
    }
  }
  editList(id: string) {
    this.edditting = true;
    this.RecipePageDataService.changeActiveItemId(id);
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetChangeValueComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          id,
        },
      }
    );

    const bottomSheet = bottomSheetRef.backdropClick().subscribe((x) => {
      this.reopen();
    });
    this.subscriptions.push(bottomSheet);
  }
  checkSelect(id) {
    const item = this.RecipePageDataService.getItem(id);

    if (item) {
      return true;
    }
    return false;
  }
  reopen() {
    const bottomSheetRef = this.matBottomSheet.open(
      CookingStoryBottomSheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          ingredients: this.ingredients,
        },
      }
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    if (!this.edditting) {
      this.RecipePageDataService.clearList();
    }
  }
  save() {
    if (this.selectedItem.length > 0) {
      this.RecipePageDataService.saveCart(this.selectedItem);

      this.cookingStoryGroceryService.openPopUp.next('به لیست خرید اضافه شد');
      this.bottomSheetRef.dismiss();
    }
  }
  getDescription(data: RecipeIngredientModel) {
    const res = this.RecipePageDataService.getItem(data._id);
    const amount = res?.amount ? res?.amount : '';
    const unitDescription = res?.unitDescription ? res?.unitDescription : '';
    return amount + ' ' + unitDescription;
  }
}
